// types_schedule.js
//Getters
export const SCH_GET_DATA = "schedule/getschedule";

//Actions
export const SCH_ACTION_SUBMIT_SCHEDULE = "schedule/addschedule";
export const SCH_SET_SCHEDULE = "schedule/setschedules";


// WEBPACK FOOTER //
// ./src/store/types_schedule.js